import styled from 'styled-components/macro';
import { Alert } from '@yme/atoms/alert';
import { CustomScroll } from '@yme/atoms/custom-scroll';
import { colorCoreGray200, colorCoreWhite1000, hexColorBlackTransparent50, } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { ADAPTIVE } from '@yme/tokens/screen';
import { getTextStyles } from '@yme/utils/styles';
export const ScrollableContainerStyled = styled.div `
  position: relative;

  &::before,
  &::after {
    content: '';
    display: block;
    width: 16px;
    height: 100%;
    position: absolute;
    top: 0;
    opacity: 0;
    transition: 0.3s;
  }

  &::before {
    left: 0;
    background-image: linear-gradient(
      to left,
      rgba(237, 237, 237, 0) 0%,
      rgba(237, 237, 237, 1) 100%
    );

    ${({ isLeftGradientVisible }) => isLeftGradientVisible && 'opacity: 1'};
  }

  &::after {
    right: 0;
    background-image: linear-gradient(
      to right,
      rgba(237, 237, 237, 0) 0%,
      rgba(237, 237, 237, 1) 100%
    );

    ${({ isRightGradientVisible }) => isRightGradientVisible && 'opacity: 1'};
  }
`;
export const TableContainerStyled = styled.div `
  overflow-x: auto;
  user-select: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  ${ADAPTIVE.minWidth.desktop} {
    &::-webkit-scrollbar {
      display: initial;
    }

    ${CustomScroll};
  }

  table {
    border: 1px solid ${hexColorBlackTransparent50};
    border-radius: ${CORNER_RADIUS.xs};
    border-spacing: 0;
    box-sizing: border-box;
    overflow: hidden;

    td {
      min-width: 200px;
      max-width: 200px;
      padding: 16px;
      border: none;
      box-sizing: border-box;

      ${getTextStyles('Ubuntu', 400, 14, 20)}

      vertical-align: top;
      word-break: break-word;
      background-color: ${colorCoreWhite1000};
    }

    tr {
      &:nth-child(odd) {
        td {
          background-color: ${colorCoreGray200};
        }
      }

      &:first-child {
        td {
          ${getTextStyles('Ubuntu', 500, 16, 24)}

          border-bottom: 1px solid ${hexColorBlackTransparent50};
        }
      }
    }
  }
`;
export const AlertStyled = styled(Alert) `
  margin-bottom: 24px;
`;
